import { AddressValidationResponseItem } from "../interfaces/DHLInterface";

//DHL adress string builder
export const dhlAddressStringBuilder = (
  address: AddressValidationResponseItem
) => {
  const countyName = address.countyName ? ` ${address.countyName}` : "";
  const postalCode = address.postalCode ? ` ${address.postalCode}` : "";
  return `${address.cityName}${countyName}${postalCode}`;
};
